import { vnTemplate } from "./vnTemplate";
export class validationsList_template extends vnTemplate {
    getTemplateHtml() {
        return `
            <div data-bind="css: { hide: isHidden }, style: {width: width()}" class="w-validation-errors">
                <div class="val-error-header">
                    <strong data-bind="text: msg" class="val-error-header-title icon i-notice-alert"></strong>
                    <button class="close-button icon i-close-2" type="button"></button>
                </div>
                
                <ul data-bind="foreach: messages" class="val-error-list">
                    <li class="val-error-item icon i-arrow-right-before" >
                        <span class="validation-label" data-bind="text: label" ></span>
                        <span class="validation-message" data-bind="html: message" ></span>
                    </li>
                </ul>
            </div>
            `;
    }
    getTemplateName() {
        return "validationList-template";
    }
    getMainElementType() {
        return "div";
    }
    getMainElementClasses() {
        return [];
    }
    buildViewModel() {
        // define the viewmodel data/functions
        return {
            width: ko.observable('50em'),
            msg: ko.observable("There seems to be a problem"),
            messages: ko.observableArray([]),
            show: ko.observable("none"),
            isHidden: ko.observable(1)
        };
    }
    setSingleMessage(message) {
        this.getTemplateViewModel().messages([message]);
        this.getTemplateViewModel().isHidden(0);
    }
    clearMessages() {
        this.getTemplateViewModel().messages([]);
        this.getTemplateViewModel().msg("There seems to be a problem");
        this.getTemplateViewModel().isHidden(1);
    }
    setMessages(messages) {
        this.clearMessages();
        let allMessages = [];
        for (let m of messages) {
            for (let mm of m.messages) {
                let tmp = { field: m.field, label: m.label, message: mm };
                allMessages.push(tmp);
            }
        }
        this.getTemplateViewModel().messages(allMessages);
        this.getTemplateViewModel().isHidden(0);
    }
    setMessageUsingDefaultFormat(errors) {
        this.clearMessages();
        this.getTemplateViewModel().msg(errors.message);
        if (errors.type == "validation" || errors.type == "error_validation") {
            let validations = [];
            for (let v of errors.validations) {
                for (let vm of v.messages) {
                    validations.push({ field: v.field, label: v.label, message: vm });
                }
            }
            this.getTemplateViewModel().messages(validations);
        }
        this.getTemplateViewModel().isHidden(0);
    }
    setWidth(width) {
        this.getTemplateViewModel().width(width);
    }
}
